import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import { AppButton } from '@/ui/buttons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--default-padding);
  background-color: var(--red-main-20);
  border-radius: var(--medium-border-radius);
  padding: var(--big-padding);
  width: 100%;
  margin-bottom: var(--default-padding);
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--xsmall-padding);
`;

const StyledHeading = styled.h2`
  color: var(--red-darkest);
  font-size: var(--body-font-size);
  line-height: 140%;
  font-weight: 600;
  margin: 0;
`;

const StyledDescription = styled.p`
  color: var(--red-darkest);
  font-size: var(--small-font-size);
  line-height: 140%;
  margin: 0;
`;

export const BlockEmailsBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const handleEnableEmails = () => {
    currentAccount?.isSystem
      ? navigate(
          RedirectPaths[RedirectPathsEnum.ACCOUNTS_EMAILS_AND_DELIVERY](
            currentAccount?.id as string,
          ),
        )
      : navigate(
          RedirectPaths[RedirectPathsEnum.ACCOUNT_EMAILS_AND_DELIVERY](),
        );
  };

  return (
    <StyledBanner id="block-emails-banner">
      <StyledContent>
        <StyledHeading>{t('account.emails.banner.title')}</StyledHeading>
        <StyledDescription>
          {t('account.emails.banner.description')}
        </StyledDescription>
      </StyledContent>
      <AppButton
        label={t('account.emails.banner.cta')}
        onClick={handleEnableEmails}
      />
    </StyledBanner>
  );
};
